import { START } from "../constants/action-types";
import { SET_TIPO } from "../constants/action-types";
import { SET_PRODOTTO } from "../constants/action-types";
import { SET_DOVE } from "../constants/action-types";
import { SET_CF } from "../constants/action-types";
import { SET_DATI_PERSONALI } from "../constants/action-types";
import { SET_CONSENSI } from "../constants/action-types";
import { SET_GIORNO } from "../constants/action-types";
import { SET_GIORNO_ONLY } from "../constants/action-types";
import { SET_ORARIO } from "../constants/action-types";
import { SET_FILIALE } from "../constants/action-types";
import { CLEAR_FILIALI } from "../constants/action-types";
import { CLEAR_CONSENSI } from "../constants/action-types";
import { SET_FILIALI } from "../constants/action-types";
import { SET_DISPONIBILITA } from "../constants/action-types";
import { SET_RECAP } from "../constants/action-types";
import { CLEAR_DISPONIBILITA } from "../constants/action-types";
import { SET_VECCHIO_APPUNTAMENTO } from "../constants/action-types";
import { SET_OPP_ID } from "../constants/action-types";
import { SET_PRODUCT_FROM_PARAMS } from "../constants/action-types";
import { SET_DOVE_NO_RESET } from "../constants/action-types";
import { SET_UTM } from "../constants/action-types";
import { SET_FLUSSO_MODIFICA } from "../constants/action-types";
import { SET_MODIFICANDO } from "../constants/action-types";
import { SET_HISTORY_BACK } from "../constants/action-types";
import { CLEAR_HISTORY_BACK } from "../constants/action-types";
import { START_BACK_EVENT } from "../constants/action-types";
import { END_BACK_EVENT } from "../constants/action-types";
import { SAVE_TOKEN } from "../constants/action-types";
import { GET_DATA_FROM_TOKEN } from "../constants/action-types";
import { SET_LAST_BACK_TIMESTAMP } from "../constants/action-types";
import { SET_SOURCE } from "../constants/action-types";
import { SET_FIRST_LOAD } from "../constants/action-types";
import { SET_CAP_EXCLUDED } from "../constants/action-types";
import { SET_FOUND_DB_COMPASS } from "../constants/action-types";
import { SET_TELEFONICO } from "../constants/action-types";
import { SET_FAFUNNEL_TRIGGERED } from "../constants/action-types";
import { SET_OVERLAY } from "../constants/action-types";
import { SET_FLOW_SWITCH } from "../constants/action-types";
import { SET_RICONTATTO } from "../constants/action-types";
import { SET_RICONTATTO_CF } from "../constants/action-types";
import { SET_RICONTATTO_RICHIESTO } from "../constants/action-types";
import { SET_FILIALE_RICONTATTO } from "../constants/action-types";
import { SET_ACCESS_ROUTE } from "../constants/action-types";

export function setAccessRoute(payload) {
  return { type: SET_ACCESS_ROUTE, payload }
};

export function setFilialeRicontatto(payload) {
  return { type: SET_FILIALE_RICONTATTO, payload }
};

export function setRicontattoRichiesto(payload) {
  return { type: SET_RICONTATTO_RICHIESTO, payload }
};

export function setRicontattoCf(payload) {
  return { type: SET_RICONTATTO_CF, payload }
};

export function setTipoAppuntamento(payload) {
  return { type: SET_TIPO, payload }
};

export function start() {
    return { type: START }
};

export function setProdotto(payload) {
    return { type: SET_PRODOTTO, payload }
};

export function setDove(payload) {
    return { type: SET_DOVE, payload }
};

export function setCF(payload) {
    return { type: SET_CF, payload }
};

export function setDatiPersonali(payload) {
    return { type: SET_DATI_PERSONALI, payload }
};

export function setConsensi(payload) {
    return { type: SET_CONSENSI, payload }
};

export function setGiorno(payload) {
    return { type: SET_GIORNO, payload }
};

export function setGiornoOnly(payload) {
    return { type: SET_GIORNO_ONLY, payload }
};

export function setOrario(payload) {
    return { type: SET_ORARIO, payload }
};

export function setFiliale(payload) {
    return { type: SET_FILIALE, payload }
};

export function clearFiliali() {
    return { type: CLEAR_FILIALI }
};

export function setFiliali(payload) {
    return { type: SET_FILIALI, payload }
};

export function setDisponibilita(payload) {
    return { type: SET_DISPONIBILITA, payload }
};

export function setRecap(payload) {
    return { type: SET_RECAP, payload }
};

export function clearDisponibilita(payload) {
    return { type: CLEAR_DISPONIBILITA, payload }
};

export function setVecchioAppuntamento(payload) {
    return { type: SET_VECCHIO_APPUNTAMENTO, payload }
};

export function setOppID(payload) {
    return { type: SET_OPP_ID, payload }
};

export function setProductFromParams(payload) {
    return { type: SET_PRODUCT_FROM_PARAMS, payload }
};

export function setDoveNoReset(payload) {
    return { type: SET_DOVE_NO_RESET, payload }
};

export function setUtm(payload) {
    return { type: SET_UTM, payload }
};

export function setFlussoModifica(payload) {
    return { type: SET_FLUSSO_MODIFICA, payload }
};

export function setModificando(payload) {
    return { type: SET_MODIFICANDO, payload }
};

export function clearConsensi(payload) {
    return { type: CLEAR_CONSENSI, payload }
};

export function setHistoryBack(payload) {
    return { type: SET_HISTORY_BACK, payload }
};

export function clearHistoryBack(payload) {
    return { type: CLEAR_HISTORY_BACK, payload }
};

export function startBackEvent(payload) {
    return { type: START_BACK_EVENT, payload }
};

export function endBackEvent(payload) {
    return { type: END_BACK_EVENT, payload }
};

export function saveToken(payload) {
    return { type: SAVE_TOKEN, payload }
};

export function getDataFromToken(payload) {
    return { type: GET_DATA_FROM_TOKEN, payload }
};

export function setLastBackTimestamp(payload) {
  return { type: SET_LAST_BACK_TIMESTAMP, payload }
};

export function setSource(payload) {
  return { type: SET_SOURCE, payload }
};

export function setFirstLoad(payload) {
  return { type: SET_FIRST_LOAD, payload }
};

export function setCapExcluded(payload) {
  return { type: SET_CAP_EXCLUDED, payload }
};

export function setFoundDbCompass(payload) {
  return { type: SET_FOUND_DB_COMPASS, payload }
};

export function setTelefonico(payload) {
  return { type: SET_TELEFONICO, payload }
};

export function setFaFunnerTriggered(payload) {
  return { type: SET_FAFUNNEL_TRIGGERED, payload }
};

export function setOverlay(payload) {
  return { type: SET_OVERLAY, payload }
};

export function setFlowSwitch(payload) {
  return { type: SET_FLOW_SWITCH, payload }
};

export function setRicontatto(payload) {
  return { type: SET_RICONTATTO, payload }
};


// WEBPACK FOOTER //
// ./src/actions/index.js